import './Home.style.less'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { USER_ROLE } from '@/constant/user'
import { useAuth } from '@/providers/auth.provider'
import { DEFAULT_ROUTE } from '@/constant/common'
import { useMobileSidebar } from '@/layout/components/MobileSidebarContext'
import { useCompanySettingShowModules } from '@/hooks/useCompanySettingShowModules'
import { getSupplierCanCreateInspectionSetting } from '@/screens/SystemConfigure/UserManagment/UserManagment.service'
import { useQuery } from 'react-query'

function Home() {
  const { user } = useAuth()
  const userRole = user?.subscription?.role_access?.role
  const navigate = useNavigate()
  const { isMobile } = useMobileSidebar()
  const { isLoading, shouldShowProductModule } = useCompanySettingShowModules(
    user?.id
  )
  const {
    data: supplierCanCreateInspection,
    isLoading: isSupplierCanCreateInspectionLoading,
  } = useQuery(
    ['supplierCanCreateInspection', user?.id],
    getSupplierCanCreateInspectionSetting,
    { enabled: Boolean(user?.id) }
  )

  const getDefaultRoute = () => {
    if (isMobile && shouldShowProductModule) return DEFAULT_ROUTE.PRODUCTS
    if (userRole === USER_ROLE.INSPECTOR) return DEFAULT_ROUTE.QSF_INSPECTION

    if (userRole === USER_ROLE.SUPPLIER) {
      if (shouldShowProductModule) {
        return DEFAULT_ROUTE.PRODUCTS
      }

      if (supplierCanCreateInspection) {
        return DEFAULT_ROUTE.QSF_INSPECTION
      }
    }

    return DEFAULT_ROUTE.PBF_ORDERS
  }

  useEffect(() => {
    if (
      isLoading ||
      isSupplierCanCreateInspectionLoading ||
      (isMobile && isLoading)
    )
      return

    navigate(getDefaultRoute())
  }, [
    isLoading,
    isSupplierCanCreateInspectionLoading,
    isMobile,
    shouldShowProductModule,
    userRole,
    supplierCanCreateInspection,
  ])

  return <div />
}

export default Home
